// noinspection JSUnresolvedVariable
import {useEffect, useState} from 'react';
import Alert from '../../components/layout/Alert';
import Table from '../../components/table/Table';
import LinkView from '../../components/table/LinkView';
import Spinner from '../../components/button/Spinner';
import Tooltip from '../../components/layout/Tooltip';
import {useNavigate, useSearchParams} from 'react-router-dom';
import api from '../../services/api';

const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then();
}

export default function TableBillet() {
    const [billets, setBillets] = useState([]);
    const [copy, setCopy] = useState([]);
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    let document = user.document;
    console.log()
    if (searchParams.get('document') !== null) {
        document = searchParams.get('document');
    }

    useEffect(() => {
        setShowAlert(false);
        setLoading(true);
        const controller = new AbortController();

        api
            .get('/billets/' + document)
            .then((response) => {
                setBillets(response.data);
                const arr = (Array(billets.length).fill(false));
                setCopy(arr);
            })
            .catch((err) => {
                setShowAlert(true);
                if (err.response.status && err.response.status === 404) {
                    setAlertMessage('Nenhum registro encontrado');
                    return
                }
                setAlertMessage('Erro ao carregar os dados');
                console.error(err);
            }).finally(() => {
            setLoading(false);
        });

        return () => controller.abort();

    }, [document]);

    return (
        <>
            <Alert color="red" message={alertMessage} show={showAlert} alertOpen={setShowAlert}/>
            <div className="pt-10 flex px-10 justify-between">
                <div className="text-blue-500 font-semibold">
                    <div className="flex">
                        <button onClick={() => {
                            navigate(-1);
                        }} className='group'>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mb-3" fill="none"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
                            </svg>
                            <Tooltip text='Voltar'/>
                        </button>
                        <h2 className="text-3xl mb-4">Boletos</h2>
                    </div>
                </div>
                <div className="h-2">
                    <Spinner loading={loading}/>
                </div>
                <div/>
            </div>
            <Table>
                <thead className="border-b bg-stone-200">
                <tr className="text-sm text-gray-900 text-center">
                    <th scope="col" className="px-2 font-medium py-4">Documento</th>
                    <th scope="col" className="px-2 font-medium">Prefixo</th>
                    <th scope="col" className="px-2 font-medium">Parcela</th>
                    <th scope="col" className="px-2 font-medium">Vencimento</th>
                    <th scope="col" className="px-2 font-medium">Valor</th>
                    <th scope="col" className="px-2 font-medium">NFE</th>
                    <th scope="col" className="px-2 font-medium">Dados NFE</th>
                    <th scope="col" className="px-2 font-medium">Link Boleto</th>
                    <th scope="col" className="px-2 font-medium">Linha Digitável</th>
                    <th scope="col" className="px-2 font-medium">Ações</th>
                </tr>
                </thead>
                <tbody>
                {
                    billets.length > 50 && setBillets(billets.slice(0, 50))
                }
                {
                    billets.map((billet, index) => (
                        <tr key={index}
                            className="odd:bg-white even:bg-gray-100 text-sm text-gray-900 font-light text-center">
                            <td className="py-4">{billet.numero}</td>
                            <td>{billet.prefixo}</td>
                            <td>{billet.parcela}</td>
                            <td>{billet.vencimento.slice(6, 8) + '/' + billet.vencimento.slice(4, 6) + '/' + billet.vencimento.slice(0, 4)}</td>
                            <td>R${billet.valor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</td>
                            <td className="underline">
                                {billet.status && <a
                                    onClick={
                                        (e) => {
                                            e.preventDefault();
                                            if (billet.link_nf !== '') {
                                                window.open(billet.link_nf, '_blank')
                                            }
                                        }
                                    } href={billet.link_nf ?? ''}>NFE</a>
                                }
                            </td>
                            <td className={'whitespace-nowrap'}>
                                Protocolo: {billet.protocolo + ' '}
                                CMC: {billet.CMC}
                            </td>
                            <td className="underline">
                                <a
                                    onClick={
                                        (e) => {
                                            e.preventDefault();
                                            if (billet.link_pdf !== '') {
                                                window.open(billet.link_pdf, '_blank')
                                            }
                                        }
                                    } href={billet.link_pdf ?? ''}>Boleto </a>
                            </td>
                            <td>
                                {!copy[index] ?
                                    <div className="group">
                                        <svg onClick={() => {
                                            copyToClipboard(billet.linha_digitavel);
                                            setCopy({...copy, [index]: true});
                                            setTimeout(() => {
                                                setCopy({...copy, [index]: false});
                                            }, 3000)
                                        }} xmlns="http://www.w3.org/2000/svg"
                                             className="cursor-pointer h-6 w-6 mx-auto"
                                             fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  strokeWidth={2}
                                                  d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"/>
                                        </svg>
                                        <Tooltip text="Copiar Linha Digitável"/>
                                    </div> :
                                    <div className="group mx-auto">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mx-auto"
                                             fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  strokeWidth={2}
                                                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
                                        </svg>
                                        <Tooltip text="Copiado"/>
                                    </div>
                                }
                            </td>
                            <td>
                                <div className={'justify-items-center relative'}><LinkView linkTo="view"/></div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    )
}
